import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const partnerAgencies = [
    { name: "Sotheby's International Realty", url: "https://www.sothebysrealty.com" },
    { name: "Christie's Real Estate", url: "https://www.christiesrealestate.com" },
    { name: "Knight Frank", url: "https://www.knightfrank.com" },
    { name: "Savills", url: "https://www.savills.com" },
  ];

  return (
    <footer className="py-12 bg-charcoal border-t border-cream/10">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Partner Agencies */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-8 pb-8 border-b border-cream/10"
        >
          <p className="font-body text-xs uppercase tracking-[0.15em] text-cream/40 mb-4 text-center">
            In Partnership With Leading Global Agencies
          </p>
          <div className="flex flex-wrap justify-center gap-6 md:gap-10">
            {partnerAgencies.map((agency) => (
              <a
                key={agency.name}
                href={agency.url}
                target="_blank"
                rel="noopener noreferrer"
                className="font-body text-xs text-cream/50 hover:text-gold-light transition-all duration-300"
              >
                {agency.name}
              </a>
            ))}
          </div>
        </motion.div>

        {/* Main Footer */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="flex flex-col md:flex-row justify-between items-center gap-4 mb-8"
        >
          <div className="flex flex-col items-center md:items-start gap-2">
            <motion.div
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.3 }}
            >
              <Logo size="sm" variant="light" showTagline />
            </motion.div>
          </div>

          {/* Tagline & Copyright */}
          <div className="text-center">
            <p className="font-body text-xs uppercase tracking-[0.2em] text-gold-light/60 mb-1">
              Expertise · Integrity · Legacy
            </p>
            <p className="font-body text-sm text-cream/50">
              © {currentYear} Agota Estate. All rights reserved.
            </p>
          </div>

          {/* Legal Links */}
          <div className="flex gap-6">
            <a
              href="/blog"
              className="font-body text-sm text-cream/50 hover:text-gold-light transition-all duration-300 link-underline"
            >
              Insights
            </a>
            <a
              href="/privacy-policy"
              className="font-body text-sm text-cream/50 hover:text-gold-light transition-all duration-300 link-underline"
            >
              Privacy Policy
            </a>
            <a
              href="/terms"
              className="font-body text-sm text-cream/50 hover:text-gold-light transition-all duration-300 link-underline"
            >
              Terms
            </a>
          </div>
        </motion.div>

        {/* Legal Disclaimer */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="pt-6 border-t border-cream/5"
        >
          <p className="font-body text-[10px] leading-relaxed text-cream/30 text-center max-w-4xl mx-auto">
            <strong className="text-cream/40">DISCLAIMER:</strong> All property listings, images, prices, and descriptions displayed on this website are for illustrative purposes only and may not represent actual properties currently available for sale. Images are AI-generated artistic representations inspired by luxury real estate in the featured locations. Agota Estate acts as a luxury property consultancy and works in collaboration with accredited partner agencies. Actual property availability, pricing, and specifications should be verified directly with our team or partner agencies. This website does not constitute an offer or solicitation for the sale of any property. All trademarks and brand names mentioned belong to their respective owners and are used for reference purposes only.
          </p>
        </motion.div>
      </div>
    </footer>
  );
};
